import loginService from '../../domain/services/login.service';
import { rolesKeys } from '../../domain/constant/user.constant';
import useSellerWorkSignal from '../../hooks/crm/useSellerWorkSignal';

const SellerWorkSignal = () => {
    useSellerWorkSignal(loginService.isLogin() && loginService.isValidRoles([rolesKeys.SELLER]));

    return null;
};

export default SellerWorkSignal;
